import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import { routerMiddleware } from 'react-router-redux'
import { connectRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { persistStore, persistCombineReducers } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import reducers from './reducers'
import { AuthFilter } from './transforms'
import { AppVersion, AppVersionAnotation, IsDevelopment } from 'common/Globals'

export const history = createBrowserHistory()

const persistConfig = {
    key: 'webphone',
    storage,
    transforms: [AuthFilter],
    version: `${AppVersion}${AppVersionAnotation}`,
    whitelist: ['auth', 'settings'],
    migrate: (state) => {
        return new Promise((resolve) => {
          // Reset state if the version has changed
          if (state._persist && state._persist.version !== persistConfig.version) {
    
            // Remove old persist items
            for(let i = 0; i < localStorage.length; i++) { 
                const key = localStorage.key(i)
                if(key.includes('persist:kavkom-webphone-v')) localStorage.removeItem(key)
            }

            resolve({});
          } else {
            resolve(state);
          }
        });
      },
}

const persistedReducer = persistCombineReducers(persistConfig, {
    router: connectRouter(history),
    ...reducers
})

function configureStore() {
    const enhancers = []
    const middlewares = [thunk, routerMiddleware(history)]

    // Add redux logger for dev mode
    if (IsDevelopment) {
        const { createLogger } = require('redux-logger')
        const logger = createLogger({
            collapsed: true
        })

        middlewares.push(logger)
    }

    if (IsDevelopment && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__())
    }

    return createStore(persistedReducer, compose(applyMiddleware(...middlewares), ...enhancers))
}

export const store = configureStore()
export const persistor = persistStore(store)
